import { sendGTMEvent } from '@next/third-parties/google';

function getDiscount(original_price, price) {
  return original_price !== price && price !== 0 ? original_price - price : 0;
}

const gtmEvent = (event, data, user) => {
  if (typeof window != undefined) {
    sendGTMEvent({
      event: event,
      ecommerce: { ...data, ...(user && { ...user }) },
    });
  }
};

// Event For Search Page
export const event_search_result_item_list = (
  inputSearchValue,
  total_items
) => {
  gtmEvent('search_term', {
    key_word: inputSearchValue,
    total_items,
  });
};

// Event For Success Page
export const event_purchase = (
  order,
  session,
  email,
  firstname,
  lastname,
  telephone
) => {
  return gtmEvent(
    'purchase',
    {
      order_id: order?.increment_id,
      value: order?.grand_total,
      tax: order?.tax_amount,
      shipping: order?.shipping_amount,
      currency: 'SAR',
      payment_mode: order?.payment?.method,
      shipping_mode: 'Home Delivery',
      region: order?.billing_address?.city || '',
      street: order?.billing_address?.street?.[0] || '',
      line_items: order?.items?.map((item) => {
        const discount = getDiscount(
          item?.extension_attributes?.original_price,
          item?.extension_attributes?.special_price
        );
        return {
          item_id: item?.sku,
          item_name: item?.name,
          ...(discount !== 0 && !isNaN(discount) && { discount }),
          ...(item?.extension_attributes?.brand_name && {
            item_brand: item?.extension_attributes?.brand_name,
          }),
          ...(item?.extension_attributes?.category_names?.at(0) && {
            item_category:
              item?.extension_attributes?.category_names?.at(0)?.name,
          }),
          ...(item?.extension_attributes?.category_names?.at(1) && {
            item_category1:
              item?.extension_attributes?.category_names?.at(1)?.name,
          }),
          ...(item?.extension_attributes?.category_names?.at(2) && {
            item_category2:
              item?.extension_attributes?.category_names?.at(2)?.name,
          }),
          ...(item?.extension_attributes?.category_names?.at(3) && {
            item_category3:
              item?.extension_attributes?.category_names?.at(3)?.name,
          }),
          ...(item?.extension_attributes?.category_names?.at(4) && {
            item_category4:
              item?.extension_attributes?.category_names?.at(4)?.name,
          }),
          ...(item?.extension_attributes?.category_names?.at(5) && {
            item_category5:
              item?.extension_attributes?.category_names?.at(5)?.name,
          }),
          price: item?.price || item?.original_price,
          quantity: item?.qty_ordered,
        };
      }),
      number_of_products: order?.items?.length,
      item_id: order?.items?.map((item) => item?.sku).join(','),
      item_name: order?.items
        ?.map((item) =>
          Array.isArray(item?.name) ? item?.name?.[0] : item?.name
        )
        .join(','),
    },
    session?.user
      ? session
      : {
          user: {
            firstname,
            lastname,
            email,
            custom_attributes: [
              { attribute_code: 'mobile_number', value: telephone },
            ],
          },
        }
  );
};

// Begin Checkout
export const event_checkout_started = (cartData) => {
  return gtmEvent('begin_checkout', {
    currency: 'SAR',
    value: cartData?.grand_total,
    items: cartData?.items?.map((item) => {
      const discount = getDiscount(
        item?.extension_attributes?.original_price,
        item?.extension_attributes?.special_price
      );
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        ...(discount !== 0 && !isNaN(discount) && { discount }),
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          category_name:
            item?.extension_attributes?.category_names?.at(0)?.name,
          category_id: item?.extension_attributes?.category_names?.at(0)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          sub_category_name:
            item?.extension_attributes?.category_names?.at(1)?.name,
          sub_category_id:
            item?.extension_attributes?.category_names?.at(1)?.id,
        }),
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
      };
    }),
  });
};

// Event Shipping Info
export const event_shipping_info = (cartData) => {
  return gtmEvent('add_shipping_info', {
    currency: 'SAR',
    value: cartData?.grand_total,
    items: cartData?.items?.map((item) => {
      const discount = getDiscount(
        item?.extension_attributes?.original_price,
        item?.extension_attributes?.special_price
      );
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        ...(discount !== 0 && !isNaN(discount) && { discount }),
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          category_name:
            item?.extension_attributes?.category_names?.at(0)?.name,
          category_id: item?.extension_attributes?.category_names?.at(0)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          sub_category_name:
            item?.extension_attributes?.category_names?.at(1)?.name,
          sub_category_id:
            item?.extension_attributes?.category_names?.at(1)?.id,
        }),
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
      };
    }),
  });
};

// Event Payment Info

export const event_payment_info = (cartData, payment_type) => {
  return gtmEvent('add_payment_info', {
    currency: 'SAR',
    value: cartData?.grand_total,
    payment_type,
    items: cartData?.items?.map((item) => {
      const discount = getDiscount(
        item?.extension_attributes?.original_price,
        item?.extension_attributes?.special_price
      );
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        ...(discount !== 0 && !isNaN(discount) && { discount }),
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          category_name:
            item?.extension_attributes?.category_names?.at(0)?.name,
          category_id: item?.extension_attributes?.category_names?.at(0)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          sub_category_name:
            item?.extension_attributes?.category_names?.at(1)?.name,
          sub_category_id:
            item?.extension_attributes?.category_names?.at(1)?.id,
        }),
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
      };
    }),
  });
};

// Event View Cart
export const event_view_cart = (cartData) => {
  return gtmEvent('view_cart', {
    currency: 'SAR',
    value: cartData?.grand_total,
    line_items: cartData?.items?.map((item) => {
      const discount = getDiscount(
        item?.extension_attributes?.original_price,
        item?.extension_attributes?.special_price
      );
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        ...(discount !== 0 && !isNaN(discount) && { discount }),
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          category_name:
            item?.extension_attributes?.category_names?.at(0)?.name,
          category_id: item?.extension_attributes?.category_names?.at(0)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          sub_category_name:
            item?.extension_attributes?.category_names?.at(1)?.name,
          sub_category_id:
            item?.extension_attributes?.category_names?.at(1)?.id,
        }),
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
        ...(cartData?.discount_amount !== 0 && {
          discount: cartData?.discount_amount,
        }),
      };
    }),
  });
};

// Event Remove From Cart
// used in mini cart, cart popup, cart page
export const event_remove_from_cart = (product) => {
  const discount = getDiscount(
    product?.extension_attributes?.original_price ||
      product?.prices_with_tax?.original_price,
    product?.extension_attributes?.special_price ||
      product?.prices_with_tax?.price
  );
  return gtmEvent('remove_from_cart', {
    currency: 'SAR',
    value:
      product?.qty *
      (product?.extension_attributes?.special_price ||
        product?.extension_attributes?.original_price ||
        product?.prices_with_tax?.price ||
        product?.prices_with_tax?.original_price),
    items: [
      {
        item_id: product?.extension_attributes?.product_sku || product?.sku,
        item_name: Array.isArray(product?.name)
          ? product?.name?.[0]
          : product?.name,
        ...(discount !== 0 && !isNaN(discount) && { discount }),
        ...(product?.extension_attributes?.brand_name && {
          item_brand: product?.extension_attributes?.brand_name,
        }),
        ...(Array.isArray(product?.option_text_brands) &&
          product?.option_text_brands?.length > 0 && {
            item_brand: product?.option_text_brands?.[0],
          }),
        ...(product?.extension_attributes?.category_names?.at(0) && {
          item_category: product?.extension_attributes?.category_names?.at(0),
        }),
        ...(product?._category_?.main_category?.name && {
          category_name: product?._category_?.main_category?.name,
          category_id: product?._category_?.main_category?.category_id,
        }),
        ...(product?.extension_attributes?.category_names?.at(1) && {
          sub_category_name:
            product?.extension_attributes?.category_names?.at(1),
        }),
        ...(product?._category_?.sub_categories?.at(0) && {
          sub_category_name: product?._category_?.sub_categories?.at(0)?.name,
          sub_category_id:
            product?._category_?.sub_categories?.at(0)?.category_id,
        }),
        image:
          product?._media_?.image?.[0]?.image ||
          `${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/catalog/product/${product?.extension_attributes?.product_image}`,
        quantity: product?.qty,
      },
    ],
  });
};

// Event Add, Update Cart
export const event_add_to_cart = (product, qty) => {
  const discount = getDiscount(
    product?.extension_attributes?.original_price ||
      product?.prices_with_tax?.original_price,
    product?.extension_attributes?.special_price ||
      product?.prices_with_tax?.price
  );
  return gtmEvent('add_to_cart', {
    currency: 'SAR',
    value:
      qty *
      (product?.extension_attributes?.special_price ||
        product?.extension_attributes?.original_price ||
        product?.prices_with_tax?.price ||
        product?.prices_with_tax?.original_price),
    items: [
      {
        item_id: product?.extension_attributes?.product_sku || product?.sku,
        item_name: Array.isArray(product?.name)
          ? product?.name?.[0]
          : product?.name,
        ...(discount !== 0 && !isNaN(discount) && { discount }),
        ...(product?.extension_attributes?.brand_name && {
          item_brand: product?.extension_attributes?.brand_name,
        }),
        ...(Array.isArray(product?.option_text_brands) &&
          product?.option_text_brands?.length > 0 && {
            item_brand: product?.option_text_brands?.[0],
          }),
        ...(product?.extension_attributes?.category_names?.at(0) && {
          item_category:
            product?.extension_attributes?.category_names?.at(0)?.name,
          category_id: product?.extension_attributes?.category_names?.at(0)?.id,
        }),
        ...(product?._category_?.main_category?.name && {
          item_category: product?._category_?.main_category?.name,
          category_id: product?._category_?.main_category?.category_id,
        }),
        ...(product?.extension_attributes?.category_names?.at(1) && {
          sub_category_name:
            product?.extension_attributes?.category_names?.at(1)?.name,
          sub_category_id:
            product?.extension_attributes?.category_names?.at(1)?.id,
        }),
        ...(product?._category_?.sub_categories?.at(0) && {
          sub_category_name: product?._category_?.sub_categories?.at(0)?.name,
          sub_category_id:
            product?._category_?.sub_categories?.at(0)?.category_id,
        }),
        image:
          product?._media_?.image?.[0]?.image ||
          `${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/catalog/product/${product?.extension_attributes?.product_image}`,
        quantity: qty,
      },
    ],
  });
};

// Event Add To Wishlist, Remove From Wishist
export const event_toggle_wishlist = (product, event_name) => {
  const discount = getDiscount(
    product?.prices_with_tax?.original_price,
    product?.prices_with_tax?.price
  );
  return gtmEvent(event_name, {
    currency: 'SAR',
    value:
      product?.prices_with_tax?.price ||
      product?.prices_with_tax?.original_price,
    items: [
      {
        item_id: product?.sku,
        item_name: product?.name?.[0],
        ...(discount !== 0 && !isNaN(discount) && { discount }),
        ...(product?.option_text_brands?.at(0) && {
          item_brand: product?.option_text_brands?.at(0),
        }),
        ...(product?._category_?.main_category?.name && {
          category_id: product?._category_?.main_category?.category_id,
          category_name: product?._category_?.main_category?.name,
        }),
        ...(product?._category_?.sub_categories?.at(0)?.name && {
          sub_category_name: product?._category_?.sub_categories?.at(0)?.name,
          sub_category_id:
            product?._category_?.sub_categories?.at(0)?.category_id,
        }),
        image: product?._media_?.image?.[0]?.image,
        quantity: 1,
      },
    ],
  });
};

// Event View Item used in pdp
export const event_view_item = (product) => {
  const discount = getDiscount(
    product?.prices_with_tax?.original_price,
    product?.prices_with_tax?.price
  );
  return gtmEvent('view_item', {
    currency: 'SAR',
    value:
      product?.prices_with_tax?.price ||
      product?.prices_with_tax?.original_price,
    items: [
      {
        item_id: product?.sku,
        item_name: product?.name?.[0],
        ...(discount !== 0 && !isNaN(discount) && { discount }),
        ...(product?.option_text_brands?.at(0) && {
          item_brand: product?.option_text_brands?.at(0),
        }),
        ...(product?._category_?.main_category?.name && {
          item_category: product?._category_?.main_category?.name,
          category_id: String(product?._category_?.main_category?.category_id),
        }),
        ...(product?._category_?.sub_categories?.at(0)?.name && {
          sub_category_id:
            product?._category_?.sub_categories?.at(0)?.category_id,
          sub_category_name: product?._category_?.sub_categories?.at(0)?.name,
        }),
        image: product?._media_?.image?.[0]?.image,
        quantity: 1,
      },
    ],
  });
};

// Event View Item List
// used in category page
export const event_view_item_list = (currentCategory, productsLength) =>
  gtmEvent('category_viewed', {
    item_list_id: String(currentCategory?.id),
    item_list_name: currentCategory?.name,
    product_count: productsLength,
  });

// Event Sub Category View
export const event_sub_view_item_list = (parentCategory, subCategory) =>
  gtmEvent('sub_category_viewed', {
    category_id: String(parentCategory?.id),
    category_name: parentCategory?.name,
    sub_category_id: String(subCategory?.id),
    sub_category_name: subCategory?.name,
    product_count: subCategory?.product_count,
  });

// Login, Logout, Register Event
export const event_user_auth = (user, event_name = 'user_login') => {
  const { firstname, lastname, email, id, mobilenumber } = user || {};
  const userData = {
    firstname,
    lastname,
    ...(id && { user_id: id }),
    ...(email ? { email } : {}),
    ...(mobilenumber ? { mobilenumber } : {}),
  };
  return gtmEvent(event_name, userData);
};

// Banner Clicked
// used in swiper, each banner in home page
export const banner_event = (banner_name, banner_link) => {
  return gtmEvent('banner_clicked', {
    banner_link,
    banner_name,
  });
};

export const update_cart_event = (cartItems) => {
  return gtmEvent('cart_updated', {
    line_items: cartItems?.map((item) => {
      return {
        category_name:
          item?._category_?.main_category?.name ||
          item?.category?.[1]?.name ||
          item?.extension_attributes?.category_names?.[1]?.name,
        sub_category_name:
          item?._category_?.sub_categories?.[0]?.name ||
          item?.category?.[2]?.name ||
          item?.extension_attributes?.category_names?.[2]?.name,
        sku_name: item?.sku || item?.extension_attributes?.product_sku,
        product_image:
          item?._media_?.image?.[0]?.image ||
          `${process.env.NEXT_PUBLIC_IMG_BASEURL}/catalog/product/${item?.extension_attributes?.product_image}`,
        quantity: item?.qty,
        price: item?.prices_with_tax?.price || item?.price,
      };
    }),
    number_of_products: cartItems?.length,
    item_id: cartItems
      ?.map((item) => item?.sku || item?.extension_attributes?.product_sku)
      .join(','),
    item_name: cartItems
      ?.map((item) =>
        Array.isArray(item?.name) ? item?.name?.[0] : item?.name
      )
      .join(','),
    sub_total: cartItems?.reduce(
      (e, c) => e + c.qty * (c?.prices_with_tax?.price || c?.price),
      0
    ),
  });
};

export const update_wishlists_event = (products) => {
  return gtmEvent('wishlist_updated', {
    line_items: products?.map((item) => {
      const discount = getDiscount(
        item?.prices_with_tax?.original_price,
        item?.prices_with_tax?.price
      );
      return {
        category_name: item?._category_?.main_category?.name,
        sub_category_name: item?._category_?.sub_categories?.[0]?.name,
        sku_name: item?.sku,
        product_image: item?._media_?.image?.[0]?.image,
        quantity: 1,
        price: item?.prices_with_tax?.price,
        ...(discount !== 0 && !isNaN(discount) && { discount }),
      };
    }),
    number_of_products: products?.length,
    item_id: products?.map((item) => item?.sku).join(','),
    item_name: products?.map((item) => item?.name?.[0]).join(','),
    value: products?.reduce(
      (price, cur) => cur?.prices_with_tax?.price + price,
      0
    ),
  });
};

// Language Change Event
export const change_language_event = (language) => {
  return gtmEvent('language_change', {
    language,
  });
};

// Payment Failure
export const payment_failure_event = (amount, mode, number_of_products) => {
  return gtmEvent('payment_failed', {
    amount,
    mode,
    number_of_products,
  });
};
